<ion-button
    shape="round"
    class="icon-button"
    [style.--border-width]="border ? '1px' : 0"
    [style.--border-color]="borderColor || 'transparent'"
    [style.--ripple-color]="rippleColor"
    [style.--background]="backgroundColor"
    [style.--background-focused]="backgroundHoverColor"
    [style.--background-hover]="backgroundHoverColor"
    [style.--button-size]="buttonSize ? buttonSize + 'px' : undefined"
    [ngClass]="{
        'icon-button-circle': display === 'circle',
        'icon-button-square': display === 'square'
    }"
    (click)="onButtonClick()"
    [disabled]="disabled">
    <lib-svg-icon
        [size]="size"
        [iconName]="iconName"
        slot="icon-only"
        [color]="color"
        [useFillAsStrokeColor]="useFillAsStrokeColor" />
</ion-button>
